<template>
  <div class="col-12">
    <form @submit.prevent="getItens" ref="formFiltros">
      <div class="row">
        <div class="col-md-6">
          <label><b>Nome da Unidade</b></label>
          <div class="input-group mb-3">
            <b-input
              placeholder="Pesquisar por Nome da Unidade"
              class="form-control search-input"
              type="text"
              v-model="search"
              aria-describedby="input-search"
            />
            <div
              class="input-group-append"
              role="button"
              @click.prevent="getItens"
            >
              <span class="input-group-text" id="input-search"
                ><i class="fas fa-search search-icon"
              /></span>
            </div>
          </div>
        </div>

        <form-select
          v-model="publicoAlvo"
          :itens="$root.arrays.acolhimento_publico_alvo"
          label="Público-alvo"
          :multiple="true"
          grid="6"
        />

        <div class="col-md-12 mb-5">
          <label><b>Vagas Disponíveis</b></label>
          <vue-slider
            v-if="max !== null"
            v-model="vagas"
            :min="min"
            :max="max"
            :tooltip="'always'"
            :tooltip-placement="'bottom'"
          ></vue-slider>
        </div>

        <div class="col-md-12 mb-3">
          <label><b>Vagas Ocupadas</b></label>
          <vue-slider
            v-if="max_ocupadas !== null"
            v-model="vagasOcupadas"
            :min="min_ocupadas"
            :max="max_ocupadas"
            :tooltip="'always'"
            :tooltip-placement="'bottom'"
          ></vue-slider>
        </div>
      </div>
      <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
        <div class="col-auto px-2 text-right">
          <button
            class="btn btn-default"
            @click.prevent="
              limparFiltros();
              $emit('clearfiltro');
            "
          >
            <i class="fas fa-times"></i>
          </button>

          <button
            type="button"
            class="btn btn-secondary"
            @click.prevent="limparFiltros()"
          >
            {{ $t("Limpar Filtros") }}
          </button>
          <button
            class="btn btn-success btn-submit"
            data-style="zoom-in"
            type="submit"
          >
            <i class="fas fa-chart-bar"></i>
            {{ $t("Filtrar") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  props: [],
  data() {
    return {
      search: "",
      vagas: [0, 0],
      vagasOcupadas: [0, 0],
      publicoAlvo: [],
      min: 0,
      max: null,
      min_ocupadas: 0,
      max_ocupadas: null,
    };
  },
  created() {
    this.min = 0;
    this.max = 50;
    this.min_ocupadas = 0;
    this.max_ocupadas = 50;
  },
  mounted() {
    this.getVagasMaximas();
  },
  methods: {
    limparFiltros() {
      this.search = "";
      this.vagas = [0, 0];
      this.vagasOcupadas = [0, 0];
      this.publicoAlvo = [];
      this.getVagasMaximas();
    },
    getVagasMaximas() {
      axios
        .get("api/dashboard/acolhimentos/unidades/get/vagasmaximas")
        .then((response) => {
          this.max = response.data.vagas;
          this.max_ocupadas = response.data.vagas;
          this.vagas = [0, this.max];
          this.vagasOcupadas = [0, this.max_ocupadas];
          this.getItens();
        });
    },
    getItens() {
      this.$emit(
        "setvalues",
        this.publicoAlvo,
        this.vagasOcupadas,
        this.vagas,
        this.search
      );
      this.$emit("getitens");
    },
  },
};
</script>
